import { Logger } from '../models/logger';


export class SafeExecUtils {
    private static get logger() {
        return Logger.getLogger('SafeExecUtils');
    };

    public static exec<T>(func: () => T, onErrorFn?: () => void, defaultValue?: T): T {
        try {
            return func();
        } catch (e) {
            if (onErrorFn) {
                try {
                    onErrorFn();
                } catch (ex) {
                    SafeExecUtils.logger.error({
                        error: ex,
                        message: 'Failed to execute onErrorFn',
                    });
                }
            }
            SafeExecUtils.logger.error({
                error: e,
                message: 'Failed to safe execute',
            });
            return defaultValue;
        }
    }

    public static execNoLog(func: () => void): void {
        try {
            func();
        } catch (e) {
            // Suppressed
        }
    }
}
